"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.diff = exports.iterate = exports.sift = exports.replaceOrAppend = exports.merge = exports.fork = exports.intersects = exports.flat = exports.list = exports.range = exports.unique = exports.cluster = exports.min = exports.max = exports.select = exports.objectify = exports.replace = exports.counting = exports.alphabetical = exports.sort = exports.last = exports.first = exports.sum = exports.boil = exports.group = void 0;
/**
 * Sorts an array of items into groups. The return value is a map where the keys are
 * the group ids the given getGroupId function produced and the value is an array of
 * each item in that group.
 */
var group = function (array, getGropuId) {
    return array.reduce(function (acc, item) {
        var _a;
        var _b;
        var groupId = getGropuId(item);
        var groupList = (_b = acc[groupId]) !== null && _b !== void 0 ? _b : [];
        return __assign(__assign({}, acc), (_a = {}, _a[groupId] = __spreadArray(__spreadArray([], groupList, true), [item], false), _a));
    }, {});
};
exports.group = group;
/**
 * Go through a list of items, starting with the first item,
 * and comparing with the second. Keep the one you want then
 * compare that to the next item in the list with the same
 *
 * Ex. const greatest = () => boil(numbers, (a, b) => a > b)
 */
var boil = function (array, compareFunc) {
    var _a;
    if (!array || ((_a = array.length) !== null && _a !== void 0 ? _a : 0) === 0)
        return null;
    return array.reduce(compareFunc);
};
exports.boil = boil;
/**
 * Sum all numbers in an array. Optionally provide a function
 * to convert objects in the array to number values.
 */
var sum = function (array, fn) {
    return (array || []).reduce(function (acc, item) { return acc + (fn ? fn(item) : item); }, 0);
};
exports.sum = sum;
/**
 * Get the first item in an array or a default value
 */
var first = function (array, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    return (array === null || array === void 0 ? void 0 : array.length) > 0 ? array[0] : defaultValue;
};
exports.first = first;
/**
 * Get the last item in an array or a default value
 */
var last = function (array, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    return (array === null || array === void 0 ? void 0 : array.length) > 0 ? array[array.length - 1] : defaultValue;
};
exports.last = last;
/**
 * Sort an array without modifying it and return
 * the newly sorted value
 */
var sort = function (array, getter, desc) {
    if (desc === void 0) { desc = false; }
    if (!array)
        return [];
    var asc = function (a, b) { return getter(a) - getter(b); };
    var dsc = function (a, b) { return getter(b) - getter(a); };
    return array.slice().sort(desc === true ? dsc : asc);
};
exports.sort = sort;
/**
 * Sort an array without modifying it and return
 * the newly sorted value. Allows for a string
 * sorting value.
 */
var alphabetical = function (array, getter, dir) {
    if (dir === void 0) { dir = 'asc'; }
    if (!array)
        return [];
    var asc = function (a, b) { return ("" + getter(a)).localeCompare(getter(b)); };
    var dsc = function (a, b) { return ("" + getter(b)).localeCompare(getter(a)); };
    return array.slice().sort(dir === 'desc' ? dsc : asc);
};
exports.alphabetical = alphabetical;
var counting = function (list, identity) {
    return list.reduce(function (acc, item) {
        var _a;
        var _b;
        var id = identity(item);
        return __assign(__assign({}, acc), (_a = {}, _a[id] = ((_b = acc[id]) !== null && _b !== void 0 ? _b : 0) + 1, _a));
    }, {});
};
exports.counting = counting;
/**
 * Replace an element in an array with a new
 * item without modifying the array and return
 * the new value
 */
var replace = function (list, newItem, match) {
    if (!list)
        return [];
    if (!newItem)
        return __spreadArray([], list, true);
    for (var idx = 0; idx < list.length; idx++) {
        var item = list[idx];
        if (match(item, idx)) {
            return __spreadArray(__spreadArray(__spreadArray([], list.slice(0, idx), true), [
                newItem
            ], false), list.slice(idx + 1, list.length), true);
        }
    }
    return __spreadArray([], list, true);
};
exports.replace = replace;
/**
 * Convert an array to a dictionary by mapping each item
 * into a dictionary key & value
 */
var objectify = function (array, getKey, getValue) {
    if (getValue === void 0) { getValue = function (item) { return item; }; }
    return array.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[getKey(item)] = getValue(item), _a)));
    }, {});
};
exports.objectify = objectify;
/**
 * Select performs a filter and a mapper inside of a reduce,
 * only iterating the list one time.
 *
 * Ex. select([1, 2, 3, 4], x => x*x, x > 2) == [9, 16]
 */
var select = function (array, mapper, condition) {
    return array.reduce(function (acc, item) {
        if (!condition(item))
            return acc;
        return __spreadArray(__spreadArray([], acc, true), [mapper(item)], false);
    }, []);
};
exports.select = select;
/**
 * Max gets the greatest value from a list
 *
 * Ex. max([{ num: 1 }, { num: 2 }], x => x.num) == 2
 */
var max = function (array, getter) {
    var get = getter ? getter : function (v) { return v; };
    return (0, exports.boil)(array, function (a, b) { return (get(a) > get(b) ? a : b); });
};
exports.max = max;
/**
 * Min gets the smallest value from a list
 *
 * Ex. max([{ num: 1 }, { num: 2 }], x => x.num) == 1
 */
var min = function (array, getter) {
    var get = getter ? getter : function (v) { return v; };
    return (0, exports.boil)(array, function (a, b) { return (get(a) < get(b) ? a : b); });
};
exports.min = min;
/**
 * Splits a single list into many lists of the desired size. If
 * given a list of 10 items and a size of 2, it will return 5
 * lists with 2 items each
 */
var cluster = function (list, size) {
    if (size === void 0) { size = 2; }
    var clusterCount = Math.ceil(list.length / size);
    return new Array(clusterCount).fill(null).map(function (_c, i) {
        return list.slice(i * size, i * size + size);
    });
};
exports.cluster = cluster;
/**
 * Given a list of items returns a new list with only
 * unique items. Accepts an optional identity function
 * to convert each item in the list to a comparable identity
 * value
 */
var unique = function (array, toKey) {
    var valueMap = array.reduce(function (acc, item) {
        var _a;
        var key = toKey ? toKey(item) : item;
        if (acc[key])
            return acc;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = item, _a));
    }, {});
    return Object.values(valueMap);
};
exports.unique = unique;
/**
 * Creates a generator that will produce an iteration through
 * the range of number as requested.
 *
 * @example for (const i of _.range(3, 3*3, 3)) { console.log(i) }
 */
function range(start, end, step) {
    var i;
    if (step === void 0) { step = 1; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                i = start;
                _a.label = 1;
            case 1:
                if (!(i <= end)) return [3 /*break*/, 4];
                return [4 /*yield*/, i];
            case 2:
                _a.sent();
                if (i + step > end)
                    return [3 /*break*/, 4];
                _a.label = 3;
            case 3:
                i += step;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.range = range;
/**
 * Creates a list with numbers ranging from the
 * start to the end by the given step.
 *
 * @example list(0, 3) // [0, 1, 2, 3]
 * @example list(2, 10, 2) // [2, 4, 6, 8 ,10]
 */
var list = function (start, end, step) {
    if (step === void 0) { step = 1; }
    return Array.from(range(start, end, step));
};
exports.list = list;
/**
 * Given an array of arrays, returns a single
 * dimentional array with all items in it.
 */
var flat = function (lists) {
    return lists.reduce(function (acc, list) {
        return __spreadArray(__spreadArray([], acc, true), list, true);
    }, []);
};
exports.flat = flat;
/**
 * Given two arrays, returns true if any
 * elements intersect
 */
var intersects = function (listA, listB, identity) {
    if (!listA || !listB)
        return false;
    var ident = identity !== null && identity !== void 0 ? identity : (function (x) { return x; });
    var dictB = listB.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[ident(item)] = true, _a)));
    }, {});
    return listA.some(function (value) { return dictB[ident(value)]; });
};
exports.intersects = intersects;
/**
 * Split an array into two array based on
 * a true/false condition function
 */
var fork = function (list, condition) {
    if (!list)
        return [[], []];
    return list.reduce(function (acc, item) {
        var a = acc[0], b = acc[1];
        if (condition(item)) {
            return [__spreadArray(__spreadArray([], a, true), [item], false), b];
        }
        else {
            return [a, __spreadArray(__spreadArray([], b, true), [item], false)];
        }
    }, [[], []]);
};
exports.fork = fork;
/**
 * Given two lists of the same type, iterate the first list
 * and replace items matched by the matcher func in the
 * first place.
 */
var merge = function (root, others, matcher) {
    if (!others && !root)
        return [];
    if (!others)
        return root;
    if (!root)
        return [];
    if (!matcher)
        return root;
    return root.reduce(function (acc, r) {
        var matched = others.find(function (o) { return matcher(r) === matcher(o); });
        if (matched)
            return __spreadArray(__spreadArray([], acc, true), [matched], false);
        else
            return __spreadArray(__spreadArray([], acc, true), [r], false);
    }, []);
};
exports.merge = merge;
/**
 * Replace an item in an array by a match function condition. If
 * no items match the function condition, appends the new item to
 * the end of the list.
 */
var replaceOrAppend = function (list, newItem, match) {
    if (!list && !newItem)
        return [];
    if (!newItem)
        return __spreadArray([], list, true);
    if (!list)
        return [newItem];
    for (var idx = 0; idx < list.length; idx++) {
        var item = list[idx];
        if (match(item, idx)) {
            return __spreadArray(__spreadArray(__spreadArray([], list.slice(0, idx), true), [
                newItem
            ], false), list.slice(idx + 1, list.length), true);
        }
    }
    return __spreadArray(__spreadArray([], list, true), [newItem], false);
};
exports.replaceOrAppend = replaceOrAppend;
/**
 * Given a list returns a new list with
 * only truthy values
 */
var sift = function (list) {
    var _a;
    return (_a = list === null || list === void 0 ? void 0 : list.filter(function (x) { return !!x; })) !== null && _a !== void 0 ? _a : [];
};
exports.sift = sift;
/**
 * Like a reduce but does not require an array.
 * Only need a number and will iterate the function
 * as many times as specified.
 *
 * NOTE: This is NOT zero indexed. If you pass count=5
 * you will get 1, 2, 3, 4, 5 iteration in the callback
 * function
 */
var iterate = function (count, func, initValue) {
    var value = initValue;
    for (var i = 1; i <= count; i++) {
        value = func(value, i);
    }
    return value;
};
exports.iterate = iterate;
/**
 * Returns all items from the first list that
 * do not exist in the second list.
 */
var diff = function (root, other, identity) {
    if (identity === void 0) { identity = function (t) {
        return t;
    }; }
    if (!(root === null || root === void 0 ? void 0 : root.length) && !(other === null || other === void 0 ? void 0 : other.length))
        return [];
    if (!(root === null || root === void 0 ? void 0 : root.length))
        return other;
    if (!(other === null || other === void 0 ? void 0 : other.length))
        return root;
    var bKeys = other.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[identity(item)] = true, _a)));
    }, {});
    return root.filter(function (a) { return !bKeys[identity(a)]; });
};
exports.diff = diff;
//# sourceMappingURL=array.js.map